import { IS_WEBSITE, IS_MOBILE_APP } from './env';

export interface AppConfig {
  platform: {
    isWebsite: boolean;
    isMobileApp: boolean;
    enableMobileFeatures: boolean;
    enableWebFeatures: boolean;
  };
  munshiJi: {
    showVoiceInput: boolean;
    showImageInput: boolean;
    enableCameraInput: boolean;
    passFullInventory: boolean;
    munshiModel: string;
  };
  invoice: {
    // Removed showQRCodeOnInvoice and showFreeQuantity - now handled by store config
  };
  ledger: {
    showLedger: boolean;
  };
  analytics: {
    enableEventTracking: boolean;
  };
  onboarding: {
    hasExploredPosters: boolean;
  };
}

export const activeAppConfig: AppConfig = {
  platform: {
    isWebsite: IS_WEBSITE,
    isMobileApp: IS_MOBILE_APP,
    enableMobileFeatures: IS_MOBILE_APP,
    enableWebFeatures: IS_WEBSITE,
  },
  munshiJi: {
    showVoiceInput: true,
    showImageInput: true,
    enableCameraInput: false,
    passFullInventory: true,
    munshiModel: 'gpt-4o-mini',
  },
  invoice: {
    // Removed showQRCodeOnInvoice and showFreeQuantity - now handled by store config
  },
  ledger: {
    showLedger: true
  },
  analytics: {
    enableEventTracking: true
  },
  onboarding: {
    hasExploredPosters: false
  },
};

/**
 * Merges partial app config with defaults, handling null/undefined cases
 * @param appConfig - Partial app config from database or user input
 * @returns Complete AppConfig with all fields populated
 */
export function mergeAppConfig(appConfig: Partial<AppConfig> | null | undefined): AppConfig {
  // Handle null/undefined cases
  if (!appConfig) {
    return activeAppConfig;
  }

  return {
    ...activeAppConfig,
    platform: {
      ...activeAppConfig.platform,
      ...(appConfig.platform || {}),
    },
    munshiJi: {
      ...activeAppConfig.munshiJi,
      ...(appConfig.munshiJi || {}),
    },
    invoice: {
      ...activeAppConfig.invoice,
      ...(appConfig.invoice || {}),
    },
    ledger: {
      ...activeAppConfig.ledger,
      ...(appConfig.ledger || {}),
    },
    analytics: {
      ...activeAppConfig.analytics,
      ...(appConfig.analytics || {}),
    },
    onboarding: {
      ...activeAppConfig.onboarding,
      ...(appConfig.onboarding || {}),
    },
  };
} 